import React from 'react';
import PropTypes from 'prop-types';

class Carousel extends React.PureComponent {
  render() {
    return (
      <div className="properties-detail-slider simple-slider mrg-btm-40 ">
        <div
          id={this.props.id}
          className="carousel slide escena-carousel"
          data-ride="carousel"
        >
          <div className="carousel-outer">
            <div className="carousel-inner">
              {this.props.images.map((image, index) => {
                if (this.props.restrict && index > (this.props.limit - 1)) {
                  return (
                    <div
                      key={index} // eslint-disable-line
                      className={`item ${index === 0 ? 'active' : ''}`}
                    >
                      <img
                        src="/img/restricted.png"
                        className="thumb-preview"
                        alt="Imagen restringida"
                      />
                    </div>
                  );
                }
                  return (
                    <div
                      key={index} // eslint-disable-line
                      className={`item ${index === 0 ? 'active' : ''}`}
                    >
                      <img
                        src={image.url}
                        className="thumb-preview"
                        alt={this.props.alt}
                      />
                    </div>
                  );
              })}
            </div>
            <a
              className="left carousel-control"
              href={`#${this.props.id}`}
              role="button"
              data-slide="prev"
            >
              <span
                className="slider-mover-left no-bg"
                aria-hidden="true"
              >
                <img src="/img/chevron-left.png" alt="chevron-left" />
              </span>
              <span className="sr-only">Anterior</span>
            </a>
            <a
              className="right carousel-control"
              href={`#${this.props.id}`}
              role="button"
              data-slide="next"
            >
              <span
                className="slider-mover-right no-bg"
                aria-hidden="true"
              >
                <img
                  src="/img/chevron-right.png"
                  alt="chevron-right"
                />
              </span>
              <span className="sr-only">Siguiente</span>
            </a>
          </div>

          <ol className="carousel-indicators thumbs visible-lg visible-md">
            {this.props.images.map((image, index) => {
              if (this.props.restrict && index > (this.props.limit - 1)) {
                return (
                  <li
                    key={index} // eslint-disable-line
                    data-target={`#${this.props.id}`}
                    data-slide-to={index}
                  >
                    <img src="/img/restricted.png" alt="Imagen restringida" />
                  </li>
                );
              }
                return (
                  <li
                    key={image.id || index}
                    data-target={`#${this.props.id}`}
                    data-slide-to={index}
                  >
                    <img src={image.url} alt={image.alt || this.props.alt} />
                  </li>
                );
            })}
          </ol>
        </div>
      </div>
    );
  }
}

Carousel.propTypes = {
  images: PropTypes.array,
  alt: PropTypes.string,
  restrict: PropTypes.bool,
  limit: PropTypes.number,
  id: PropTypes.string.isRequired,
};

Carousel.defaultProps = {
  images: [],
  alt: '',
  restrict: false,
  limit: 2,
};

export default Carousel;



// WEBPACK FOOTER //
// ./src/components/Carousel/index.js